import type { IPropertyBag } from '@deity-io/di-data-basics';
import { RequestExplorerActionTypes, RequestExplorerContext } from 'contexts/RequestExplorer';
import { get } from 'lodash';
import type { FC } from 'react';
import { useContext } from 'react';
import type { IContainerChildrenProps } from 'utils';
import { EditGrid } from '../../../EditGrid';

interface RequestVariablesProps extends IContainerChildrenProps {
  locked?: boolean;
  availableVariableValues?: IPropertyBag;
  // params: Record<string, string | number | undefined>;
}
const RequestVariables: FC<RequestVariablesProps> = ({ locked, availableVariableValues }) => {
  const ctx = useContext(RequestExplorerContext);
  // const ctxUI = useContext(UIContext);
  if (!ctx) {
    // eslint-disable-next-line no-console
    console.error('RequestExplorerContextProvider required');

    return <>RequestExplorerContextProvider required</>;
  }

  const variablesWithValues = ctx.state.variables.map(variableValue => {
    const systemValue = get(availableVariableValues, variableValue.key);

    return { ...variableValue, systemValue };
  });

  return (
    <EditGrid
      columns={{
        key: {
          key: 'key',
          label: 'Key',
          placeholder: 'Key',
          width: '20fr'
        },
        value: {
          key: 'value',
          label: 'Value',
          placeholder: 'Value',
          width: '20fr'
        },
        sysValue: {
          key: 'systemValue',
          label: 'systemValue',
          placeholder: '-',
          locked: true,
          width: '20fr'
        }
      }}
      value={variablesWithValues}
      checked={() => true}
      error={row => row.orgKey !== undefined}
      // onToggleChecked={(index, checked) => {
      //   ctx?.dispatch({
      //     type: RequestExplorerActionTypes.TOGGLE_PARAM,
      //     payload: { index, active: checked }
      //   });
      // }}
      onChange={(index, column, value) => {
        // if (column === 'value') {
        const payload = {
          index,
          key: undefined as string | undefined,
          value: undefined as string | undefined
        };
        payload[column] = value;
        ctx?.dispatch({
          type: RequestExplorerActionTypes.UPDATE_VARIABLE,
          payload
        });
        // }
      }}
      // onDeleteRow={index => {
      //   ctx?.dispatch({
      //     type: RequestExplorerActionTypes.DELETE_PARAM,
      //     payload: { index }
      //   });
      // }}
    />
  );
};

export default RequestVariables;
